module.exports = __webpack_public_path__ + "static/media/Hat_1.389dc5bb.jpg";